import { createSlice } from "@reduxjs/toolkit";

const initialState = {

    vehicleName: localStorage.getItem('vehicleName') 
    ? JSON.parse(localStorage.getItem('vehicleName'))
    : [],

    userAddressInfo: localStorage.getItem('userAddressInfo') 
    ? JSON.parse(localStorage.getItem('userAddressInfo'))
    : {},

    googleMap: localStorage.getItem('googleMap') 
    ? JSON.parse(localStorage.getItem('googleMap'))
    : {},

    labour: localStorage.getItem('labour') 
    ? JSON.parse(localStorage.getItem('labour'))
    : {},

    goodsInfo: localStorage.getItem('goodsInfo') 
    ? JSON.parse(localStorage.getItem('goodsInfo'))
    : [],

}

export const userAddressInfoSlice = createSlice({
    initialState,
    name: "userAddressInfoSlice",
    reducers:{
        setVehicleName: (state, action) => {
            state.vehicleName = action.payload;

            localStorage.setItem("vehicleName", JSON.stringify(state.vehicleName))
        },

        saveUserAddressInfo: (state, action) => {
          state.userAddressInfo = action.payload
          localStorage.setItem("userAddressInfo", JSON.stringify(state.userAddressInfo))
        },

        saveGoogleMap: (state, action) => {
          state.googleMap = action.payload
          localStorage.setItem("googleMap", JSON.stringify(state.googleMap))
        },
        
        saveLabour: (state, action) => {
          state.labour = action.payload
          localStorage.setItem("labour", JSON.stringify(state.labour))
        },
        
        saveGoodsInfo: (state, action) => {
          state.goodsInfo = action.payload
          localStorage.setItem("goodsInfo", JSON.stringify(state.goodsInfo))
        },

        clearVehicleName: (state, action) => {
            localStorage.removeItem("vehicleName")
            state.vehicleName = [];
          },

                  
        clearUserAddressInfo: (state, action) => {
            localStorage.removeItem("userAddressInfo")
            state.userAddressInfo = [];
          },

          
          clearGoogleMap: (state, action) => {
            localStorage.removeItem("googleMap")
            state.googleMap = [];
          },

          clearLabour: (state, action) => {
            localStorage.removeItem("labour")
            state.labour = [];
          },

          
        clearGoodsInfo: (state, action) => {
          localStorage.removeItem("goodsInfo")
          state.goodsInfo = [];
        },


    },
});

export default userAddressInfoSlice.reducer;

export const {  saveGoodsInfo, clearGoodsInfo, saveGoogleMap, clearGoogleMap, saveUserAddressInfo, setVehicleName, clearVehicleName, saveLabour, clearUserAddressInfo, clearLabour} = userAddressInfoSlice.actions